import type {WellAllocationDetails} from "@ots-frontend/ots-data";
import {OtsDialog} from "../components/OtsDialog";
import type {OtsBrand, OtsColorSchemePreference} from "../theme/OtsTheme";
import {WellAllocationInspector} from "./WellAllocationInspector";

export type WellAllocationDialogProps = {
  open: boolean;
  onClose: () => void;
  details?: WellAllocationDetails;
  loading?: boolean;
  error?: string;
  volumeUnit?: string;
  onRetry?: () => void;
  brand?: OtsBrand;
  colorScheme?: OtsColorSchemePreference;
  density?: "comfortable" | "compact";
};

/** Ticket-level allocation dialog used by Driver Activity and Ticket Grid. */
export const WellAllocationDialog = ({open, onClose, details, brand = "water-go", colorScheme = "system", density = "comfortable", ...inspectorProps}: WellAllocationDialogProps) => (
  <OtsDialog open={open} onClose={onClose} title="Well allocation" description={details?.containerName}
    brand={brand} colorScheme={colorScheme} compact={density === "compact"}>
    <WellAllocationInspector details={details} compact={density === "compact"} {...inspectorProps}/>
  </OtsDialog>
);
